import { del, get, post, put } from "@/api/client";

type I18n = Record<string, string>;

export interface QuizOption {
  id?: string;
  text: string;
  text_i18n?: I18n;
  is_correct?: boolean;
}
export interface QuizQuestion {
  id?: string;
  prompt: string;
  prompt_i18n?: I18n;
  kind: "single" | "multiple";
  options: QuizOption[];
}
export interface QuizFull {
  id: string;
  module_id: string;
  pass_threshold: number;
  questions: QuizQuestion[];
}

export interface TakingQuestion {
  id: string;
  prompt: string;
  prompt_i18n?: I18n;
  kind: "single" | "multiple";
  options: { id: string; text: string; text_i18n?: I18n }[];
}
export interface QuizTaking {
  module_id: string;
  pass_threshold: number;
  passed: boolean;
  last_score: number | null;
  questions: TakingQuestion[];
}
export interface SubmitResult {
  score: number;
  passed: boolean;
  pass_threshold: number;
}

async function unwrap<T>(p: Promise<{ ok: true; data: T } | { ok: false; err: { message: string } }>): Promise<T> {
  const r = await p;
  if (!r.ok) throw new Error(r.err.message);
  return r.data;
}

export async function getQuizAuthoring(moduleId: string, signal?: AbortSignal): Promise<QuizFull | null> {
  const d = await unwrap<{ quiz: QuizFull | null }>(get(`/api/modules/${moduleId}/quiz`, signal));
  return d.quiz;
}
export interface SaveQuizInput {
  pass_threshold: number;
  questions: {
    prompt_i18n: I18n;
    kind: "single" | "multiple";
    options: { text_i18n: I18n; is_correct: boolean }[];
  }[];
}
export async function saveQuiz(moduleId: string, input: SaveQuizInput): Promise<QuizFull> {
  const d = await unwrap<{ quiz: QuizFull }>(put(`/api/modules/${moduleId}/quiz`, input));
  return d.quiz;
}
export async function deleteQuiz(moduleId: string): Promise<void> {
  const r = await del(`/api/modules/${moduleId}/quiz`);
  if (!r.ok) throw new Error(r.err.message);
}
export const getQuizTaking = (stepId: string, signal?: AbortSignal) => unwrap<QuizTaking>(get(`/api/me/program/steps/${stepId}/quiz`, signal));
export const submitQuiz = (stepId: string, answers: Record<string, string[]>) =>
  unwrap<SubmitResult>(post(`/api/me/program/steps/${stepId}/quiz/submit`, { answers }));
